import { Navigate } from 'react-router-dom';
import { useJoinServiceGate } from '../hooks/useJoinServiceGate';
import JoinService from './JoinService';

function JoinServiceGate() {
  const { codeStatus, hasToken } = useJoinServiceGate();

  if (codeStatus === 'verifying') {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-lg font-bold text-gray-500">잠시만 기다려 주세요...</div>
      </div>
    );
  }

  if (codeStatus === 'error') {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-4">
        <div className="text-lg font-bold text-gray-500">인증에 실패했습니다.</div>
        <button
          className="text-sm text-gray-400 underline"
          onClick={() => window.location.assign('http://command/close')}
        >
          닫기
        </button>
      </div>
    );
  }

  if (!hasToken) {
    return <Navigate to="/home" replace />;
  }

  return <JoinService />;
}

export default JoinServiceGate;
